var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 10.4C3.5425 10.4 3.23657 10.2728 2.9822 10.0184C2.7274 9.76365 2.6 9.4575 2.6 9.1V1.3C2.6 0.9425 2.7274 0.63635 2.9822 0.38155C3.23657 0.127183 3.5425 0 3.9 0H9.75C10.1075 0 10.4136 0.127183 10.6684 0.38155C10.9228 0.63635 11.05 0.9425 11.05 1.3V9.1C11.05 9.4575 10.9228 9.76365 10.6684 10.0184C10.4136 10.2728 10.1075 10.4 9.75 10.4H3.9ZM3.9 9.1H9.75V1.3H3.9V9.1ZM1.3 13C0.9425 13 0.63635 12.8728 0.38155 12.6184C0.127183 12.3636 0 12.0575 0 11.7V3.25C0 3.06583 0.0624001 2.91135 0.1872 2.78655C0.311567 2.66218 0.465833 2.6 0.65 2.6C0.834167 2.6 0.98865 2.66218 1.11345 2.78655C1.23782 2.91135 1.3 3.06583 1.3 3.25V11.7H7.8C7.98417 11.7 8.13865 11.7624 8.26345 11.8872C8.38782 12.0116 8.45 12.1658 8.45 12.35C8.45 12.5342 8.38782 12.6884 8.26345 12.8128C8.13865 12.9376 7.98417 13 7.8 13H1.3ZM3.9 1.3V9.1V1.3Z",
    fill: "#797979"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3329784c88a8595de064dd1ebce1f961.svg";
export { ForwardRef as ReactComponent };